class InlineVideoPlayer {
    static init() {
        const widgets = document.querySelectorAll('.video-player--inline');
        if(!widgets) return;
        [...widgets].forEach((el) => {
            new InlineVideoPlayer(el);
        });
    }

    constructor(el) {
        this.el = el;
        this.video = el.querySelector('video');
        this.button = el.querySelector('.play-video');
        this.initPlayer();
    }

    initEvents() {
        this.button.addEventListener('click', this.buttonClickHandler.bind(this));

        this.video.addEventListener('ended', () => {
            this.video.currentTime = 0;
            this.video.play();
        });

        this.video.addEventListener('pause', () => {
            this.el.classList.remove('video-playing');
            this.el.classList.add('video-paused');
        });

        this.video.addEventListener('play', () => {
            this.el.classList.remove('video-paused');
            this.el.classList.add('video-playing');
        });
    }

    initAutoplay() {
        this.isAutoplay = this.el.classList.contains('video-autoplay');

        if(this.isAutoplay) {
            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        this.video.play();
                        observer.unobserve(this.el);
                    }
                });
            }, {threshold: 0.9});

            observer.observe(this.el);
        }
    }

    togglePlay() {
        if(this.video.paused) {
            this.video.play();
        } else {
            this.video.pause();
        }
    }

    initPlayer() {
        this.initEvents();
        this.initAutoplay();
    }

    buttonClickHandler() {
        this.togglePlay();
    }
}

export default InlineVideoPlayer;
